import { render, staticRenderFns } from "./NoticesList.vue?vue&type=template&id=2365319a&scoped=true&"
import script from "./NoticesList.vue?vue&type=script&lang=js&"
export * from "./NoticesList.vue?vue&type=script&lang=js&"
import style0 from "./NoticesList.vue?vue&type=style&index=0&id=2365319a&lang=scss&scoped=true&"
import style1 from "./NoticesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2365319a",
  null
  
)

export default component.exports